import ProgressIndicator from '../common/ProgressIndicator.vue';
import PlanPicker from './PlanPicker.vue';
export default {
  name: 'PlanSection',
  components: {
    ProgressIndicator,
    PlanPicker
  },
  props: {
    plans: {
      type: Array,
      required: true
    },
    plan: {
      type: Object,
      required: true
    },
    continueButtonAction: {
      type: Function,
      required: true
    },
    memberProfile: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$analyticsHub.track('Membership Plan Viewed', {
      event_datetime: new Date().toISOString(),
      member_id: this.memberProfile.id
    });
  }
};